window.onload = function(){
	let that = this;
    let showmorebtn = document.querySelector('.as-showmore-btn')
    let showmore = document.querySelector('.as-showmore')
    showmorebtn && showmorebtn.addEventListener('click', function(){
        if (showmore) showmore.style.maxHeight = '100vh'
    })
    //动画
	this.options = {
		root: null,
		rootMargin: "0px",
		threshold: .75,
	};
	this.$videofullHosted = document.querySelector('.as-videofull-hosted')
	this.$videoAnim = document.querySelector('.as-video-anim')
	this.$imagefullHosted = document.querySelector('.as-imagefull-hosted')
	this.$imageAnim = document.querySelector('.as-image-anim')
	// 锚点激活态
	// this.$hashIds = document.querySelectorAll('.as-hash-id');
	// this.$hashnavLinks = document.querySelectorAll('.as-header-hash-nav--link');
	// this.hashnavChange = (el) => {
	// 	for (var i = 0;i < this.$hashnavLinks.length;i++) {
	// 		this.$hashnavLinks[i].classList.remove('active')
	// 		if (this.$hashnavLinks[i].getAttribute('title').toLowerCase() == el.id.toLowerCase()) {
	// 			this.$hashnavLinks[i].classList.add('active')
	// 		}
	// 	}
	// }
	this.videofullAnim = () => {
	  this.$videofullHosted.querySelector('video').play()
	  this.$videoAnim.querySelector('video').play()
      this.$videofullHosted.classList.add('scaleDown')
      this.$videofullHosted.classList.add('opacity0')
      this.$videoAnim.classList.add('slideIn')
      this.$videoAnim.classList.add('opacity1')
	}
	this.imagefullAnim = () => {
	  this.$imagefullHosted.classList.add('opacity0')
	  this.$imageAnim.classList.add('opacity1')
	}
	this.callback = (entries, observer) => {
	  entries.forEach((entry) => {
        if (entry.isIntersecting && entry.target.classList.contains('as-videofull-hosted')) {
            this.videofullAnim()
            this.observer.unobserve(entry.target)
        }
        if (entry.isIntersecting && entry.target.classList.contains('as-imagefull-hosted')) {
            this.imagefullAnim()
            this.observer.unobserve(entry.target)
        }
		// 锚点激活态
        // if (entry.isIntersecting && entry.target.classList.contains('as-hash-id')) {
        //     this.hashnavChange(entry.target.parentNode)
        // }
	  });
	};
	
	this.observer = new IntersectionObserver(this.callback, this.options);
	this.$videofullHosted && this.observer.observe(this.$videofullHosted);
	this.$imagefullHosted && this.observer.observe(this.$imagefullHosted);

	// 锚点激活态
	// for(var i = 0;i < this.$hashIds.length;i++){
	// 	this.observer.observe(this.$hashIds[i]);
	// }

	const videoElement = document.querySelectorAll('.as-bg-video');
	for(var i = 0;i < videoElement.length;i++){
		(function(i){
			videoElement[i].addEventListener('click', function() {
				videoElement[i].querySelector('video') && videoElement[i].querySelector('video').play();
			});
		})(i)
	}
	
	if(document.querySelector('.as-header-bar')){
		let scroll_pos = 0;
		let flag = false;
		let $headerPmp = document.querySelector('.as-header-pmp')
		function imgUp() {
		$headerPmp && $headerPmp.classList.add('active')
		flag = true;
		}
		function imgDown() {
		$headerPmp && $headerPmp.classList.remove('active')
		flag = false;
		}
		window.addEventListener("scroll", function (e) {
		scroll_pos = window.scrollY;
		if (!flag && scroll_pos >= 80) {
			window.requestAnimationFrame(function () {
			imgUp();
			});
		}
		if (flag && scroll_pos <= 80) {
			window.requestAnimationFrame(function () {
			imgDown();
			});
		}
		});
	}
	
	this.$add2CartBtn = document.getElementById('AddToCart')
	this.$add2carts = document.querySelectorAll('.as-add2cart')
	for(let i = 0, els = this.$add2carts; i < els.length; i++) {
		(function(i){
			els[i].addEventListener('click', function() {
				els[i].classList.add('loading')
				that.$add2CartBtn && that.$add2CartBtn.click()
			});
		})(i)
	}

	this.$add2CartMaxx = document.getElementById('AddToCartmaxx')
	this.$add2carts1 = document.querySelectorAll('.as-add2cart1')
	if(this.$add2carts1){
		for(let i = 0, els = this.$add2carts1; i < els.length; i++) {
			(function(i){
				els[i].addEventListener('click', function() {
					els[i].classList.add('loading')
					that.$add2CartMaxx && that.$add2CartMaxx.click()
				});
			})(i)
		}
	}


	this.$add2CartBtn = document.getElementById('AddToCart')
	this.$add2carts2 = document.querySelectorAll('.as-add2cart2')
	if(this.$add2carts2){
		for(let i = 0, els = this.$add2carts2; i < els.length; i++) {
			(function(i){
				els[i].addEventListener('click', function() {
					els[i].classList.add('loading')
					that.$add2CartBtn && that.$add2CartBtn.click()
				});
			})(i)
		}
	}

	this.$addBundle = document.getElementById('AddBundle')
	this.$add2carts3 = document.querySelectorAll('.as-add2cart3')
	this.$bundle = document.querySelector('.as-bundle')
	this.$bundle && this.$bundle.click()
	if(this.$add2carts3){
		for(let i = 0, els = this.$add2carts3; i < els.length; i++) {
			(function(i){
				els[i].addEventListener('click', function() {
					els[i].classList.add('loading')
					that.$bundle && that.$bundle.click()
					that.$addBundle && that.$addBundle.click()
				});
			})(i)
		}
	}


	if(document.querySelector('.image-with-nav-slideshow .flickity-page-dots')){
		
		var $pagedots = document.querySelectorAll('.image-with-nav-slideshow .flickity-page-dots .dot')
		var $btndots = document.querySelectorAll('.dot-btn-wrap .as-dot')
		var observer = new MutationObserver((mutationList, observer) => {
			$btndots.forEach((el) => { el.classList.remove('active') });
			for(let i = 0; i < $pagedots.length; i++) {
				if($pagedots[i].classList.contains('is-selected')) $btndots[i].classList.add('active')
			}
		});
		observer.observe(document.querySelector('.image-with-nav-slideshow .flickity-page-dots'), { attributes: true, childList: true, subtree: true });
	}
	
	//监听buynow
	var $buynowbtn = document.querySelector('.shopify-payment-button__more-options')
	var $buynows = document.querySelector('.as-buy-now')
	if($buynowbtn && $buynows) {
		$buynows.addEventListener('click', function(){
			$buynowbtn.click()
		})
	}

	// var $productError = document.querySelector('.as-product-form__error-message-wrapper')
	// var $productErrorHeader = document.querySelector('.as-product-form__error-message-header')
	// var observer = new MutationObserver((mutationList, observer) => {
	// 	$productErrorHeader.innerHTML = $productError.innerHTML
	// });
	// observer.observe($productError, { attributes: true });

	this.$dots = document.querySelectorAll('.as-dot')
	this.$navdots = document.querySelectorAll('.as-image-with-nav-slideshow .dot')
	for(let i = 0, els = this.$dots; i < els.length; i++) {
		(function(i){
			els[i].addEventListener('click', function() {
				els.forEach((el) => { el.classList.remove('active') });
				els[i].classList.add('active')
				that.$navdots && that.$navdots[i].click()
			});
		})(i)
	}
}